import { Pipe, PipeTransform } from '@angular/core'
import { getPathWithoutLocale, LocaleService } from '../../../framework/locale/services/locale.service'

/**
 * Retrieves the localized version of an internal url
 */
@Pipe({
    name: 'localized_url',
})
export class LocalizedUrlPipe implements PipeTransform {
    constructor(private localeService: LocaleService) {}

    transform(val: string | string[]): string | string[] {
        if (val instanceof Array || val.startsWith('http')) {
            return val
        }

        let pathWithoutLocale = getPathWithoutLocale(val)

        if (pathWithoutLocale === '/') {
            pathWithoutLocale = ''
        }

        if (pathWithoutLocale !== '' && pathWithoutLocale[0] !== '/') {
            pathWithoutLocale = `/${pathWithoutLocale}`
        }

        while (pathWithoutLocale[0] === '/') {
            pathWithoutLocale = pathWithoutLocale.substr(1)
        }

        return `/${pathWithoutLocale}`
    }
}
